import React, { useState } from 'react'
import { Button } from 'devextreme-react'
import DeviceUpdatesSettingsModal from './DeviceUpdatesSettingsModal'

export const DeviceUpdatesSearchSettings: React.FC = () => {
  const [showDialog, setShowDialog] = useState(false)

  return (
    <>
      {showDialog && (
        <DeviceUpdatesSettingsModal onClose={() => setShowDialog(false)} />
      )}
      <div className="search-settings">
        <Button
          key="Setting Button"
          onClick={() => setShowDialog(true)}
          className="button"
          height={35}
        >
          <span className="glyphicons glyphicons-cogwheels"></span> Settings
        </Button>
      </div>
    </>
  )
}
